export const MAIN_MAX_WIDTH = 400;
export const HEADER_HEIGHT = 64;

export const SELECT_MENU_MAX_HEIGHT = 370;
